import * as React from "react";
function SvgFacebook(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M22 12.0612C22 6.50444 17.5231 2 12.0013 2C6.47694 2.00125 2 6.50444 2 12.0625C2 17.0831 5.65704 21.2451 10.4364 22V14.9696H7.89926V12.0625H10.4389V9.84402C10.4389 7.32308 11.9325 5.93076 14.216 5.93076C15.3108 5.93076 16.4544 6.12698 16.4544 6.12698V8.60168H15.1934C13.9523 8.60168 13.5648 9.37783 13.5648 10.174V12.0612H16.337L15.8945 14.9684H13.5636V21.9988C18.343 21.2438 22 17.0819 22 12.0612Z" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "src/assets/icons/facebook.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/facebook_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/facebook_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/facebook_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/facebook_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/facebook_4x.svg"
};
export { ForwardRef as ReactComponent };